import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

/**
 * Keeps a render crash from leaving a blank #root. Effect/telemetry errors
 * are not caught here; those must not throw (see SentryBootstrap).
 */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    try {
      if (typeof window.Sentry?.captureException === 'function') {
        window.Sentry.captureException(error);
      }
    } catch {
      // ignore
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            padding: 24,
            fontFamily: 'Manrope, sans-serif',
            color: '#1F2428',
            textAlign: 'center',
          }}
        >
          <p style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>This page failed to load</p>
          <p style={{ margin: 0, color: '#5c6570' }}>Refresh to try again.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              border: 0,
              borderRadius: 8,
              padding: '10px 18px',
              background: '#F5C21A',
              color: '#1F2428',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
